import { UserInfo } from './api';

export const state: { user: UserInfo | null } = {
  user: JSON.parse(localStorage.getItem('flowboard_user') || 'null'),
};

export function setUser(u: UserInfo | null): void {
  state.user = u;
  if (u) localStorage.setItem('flowboard_user', JSON.stringify(u));
  else localStorage.removeItem('flowboard_user');
}
